import React from 'react';
import { SystemDiagram } from '../components/SystemDiagram';
export function SystemPage() {
  return <div className="min-h-screen w-full bg-[#0B1120] text-slate-200 flex flex-col items-center justify-center p-4 sm:p-8 pt-20 sm:pt-8" data-id="element-847">
      <div className="w-full max-w-7xl" data-id="element-848">
        <div className="text-center mb-6 sm:mb-8" data-id="element-849">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-3 sm:mb-4" data-id="element-850">
            The HIRE System
          </h1>
          <p className="text-base sm:text-xl text-slate-400" data-id="element-851">
            Visual breakdown of our recruiting system architecture
          </p>
        </div>

        <div className="w-full bg-slate-900/50 rounded-xl border border-slate-800 p-2 sm:p-4 shadow-2xl" data-id="element-852">
          <div className="w-full h-[600px] md:h-[700px] lg:h-[800px] rounded-lg overflow-hidden bg-[#0B1120]" data-id="element-853">
            <SystemDiagram data-id="element-854" />
          </div>
        </div>
      </div>
    </div>;
}